import { child, get, onValue, ref } from 'firebase/database';
import { getFirebaseDatabase } from './firebase';

export async function getCurrentDriverLocation(driverId) {
  const db = getFirebaseDatabase();
  const snapshot = await get(child(ref(db, 'Drivers'), `${driverId}/location`));
  const value = snapshot.val();

  if (!value || typeof value.lat !== 'number' || typeof value.lng !== 'number') {
    return null;
  }

  return { lat: value.lat, lng: value.lng };
}

export function subscribeToDriverLocation(driverId, callback) {
  const db = getFirebaseDatabase();
  const driverRef = ref(db, `Drivers/${driverId}`);

  const handler = (snapshot) => {
    const value = snapshot.val();
    const loc = value?.location;

    if (loc && typeof loc.lat === 'number' && typeof loc.lng === 'number') {
      callback({ lat: loc.lat, lng: loc.lng });
    }
  };

  const unsubscribe = onValue(driverRef, handler, { onlyOnce: false });

  return () => {
    if (typeof unsubscribe === 'function') {
      unsubscribe();
    }
  };
}
